import {
  AdgroupFormData,
  BehaviorHashtagKeywordSearchInfo,
  BehaviorTag,
  CampaignFormData,
  TargetingKeywordsSearchStatus,
} from '@tt4b/ttam-enums';
import { Ref, ref, computed } from '@vue/composition-api';
import { useBehaviorData } from './../../../hooks/creation/adgroup/useBehavior/index';
import { i18n } from './../../../i18n';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';

export function usePropsVisible(options: { campaignData: Ref<CampaignFormData>; adgroupData: Ref<AdgroupFormData> }) {
  const { campaignData, adgroupData } = options;
  const { isSelectedIndustryType } = useStdAdgroupIs({
    campaignFormData: campaignData,
    adgroupFormData: adgroupData,
  });
  const visible = computed(() => !isSelectedIndustryType.value);

  return {
    visible,
  };
}

export function useContainerProps(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;

  const contentVisible = ref(false);

  const { videoCategories, creatorCategories, hashtagCategories } = useBehaviorData({
    adgroupData,
  });

  /** 是否需要追加 or 单词 */
  const needWordOr = computed(() =>
    Boolean(adgroupData.value.adTagV2.length > 0 || videoCategories.value.length || creatorCategories.value.length),
  );

  /** 已经操作过（可能校验失败） */
  const hasOperated = computed(() => Boolean(hashtagCategories.value.length));

  /** 是否是默认的文案，只有收起且无操作时候才是默认 */
  const isDefaultText = computed(() => !(contentVisible.value || hasOperated.value));

  /** 标题 */
  const title = computed(() => {
    if (isDefaultText.value) {
      return i18n.t('adgroup_target_hashtag_title');
    } else if (needWordOr.value) {
      return `${i18n.t('adgroup_target_interest_word_or')} ${i18n.t('adgroup_target_hashtag_title_focus')}`;
    } else {
      return i18n.t('adgroup_target_hashtag_title_focus');
    }
  });

  /** 描述 */
  const desc = computed(() =>
    isDefaultText.value
      ? i18n.t('adgroup_target_hashtag_desc')
      : i18n.t('adgroup_target_interest_add_behaviors_selected_num', { num: hashtagCategories.value.length }),
  );
  return {
    contentVisible,
    title,
    desc,
    hasOperated,
  };
}

export function usePropsPreofflineHashtags(options: {
  hashTags: Ref<Array<BehaviorTag & BehaviorHashtagKeywordSearchInfo>>;
}) {
  const { hashTags } = options;
  const preofflineHashTags = computed(() =>
    hashTags.value.filter(item => item.status === TargetingKeywordsSearchStatus.PRE_OFFLINE),
  );

  return {
    preofflineHashTags,
  };
}

export function usePropsOfflineHashtags(options: {
  hashTags: Ref<Array<BehaviorTag & BehaviorHashtagKeywordSearchInfo>>;
}) {
  const { hashTags } = options;
  const offlineHashTags = computed(() =>
    hashTags.value.filter(item =>
      [TargetingKeywordsSearchStatus.OFFLINE, TargetingKeywordsSearchStatus.LEGAL_OFFLINE].includes(item.status),
    ),
  );

  return {
    offlineHashTags,
  };
}
